export default "__VITE_ASSET__DqohaGNI__"